import { startOfWeekIntl } from '@plandok/core'
import { addDays, addWeeks, format } from 'date-fns'

export const getWeekRange = (index: number) => {
   const date = addWeeks(startOfWeekIntl(new Date()), index)
   return [...Array(7)].map((_, i) => addDays(date, i))
}

export const formatDates = (date: Date) => format(date, 'yyyy-LL-dd')
